// extracted by mini-css-extract-plugin
var _1 = "LoadingIndicator-module__adaptColor--abQ3d";
var _2 = "LoadingIndicator-module__card--rdYXp";
var _3 = "LoadingIndicator-module__dot--aKFxx";
var _4 = "LoadingIndicator-module__last--gInZq";
var _5 = "LoadingIndicator-module__middle--zX1QB";
var _6 = "LoadingIndicator-module__typing--nyMaU";
var _7 = "LoadingIndicator-module__wrapper--coovG";
export { _1 as "adaptColor", _2 as "card", _3 as "dot", _4 as "last", _5 as "middle", _6 as "typing", _7 as "wrapper" }
